<template>
  <div class="c-app flex-row align-items-center mt-4">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Forgot Password</h1>
                <p class="text-muted">登録したメールアドレスをご記入ください。</p>
                <CInput
                  v-model="user.email"
                  placeholder="Email"
                  autocomplete="email">
                  <template #prepend-content><CIcon name="cil-envelope-closed"/></template>
                </CInput>
                <CRow>
                  <CCol col="12" class="text-center">
                    <CButton color="success" class="px-4" @click="send()">送信</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      user:{
        email: "",
      }
    }
  },
  methods: {
    send () {
      if(this.user.email === ""){
        this.$swal('エラー', "メールアドレスを入力してください", 'error');
      }
      let api = new ApiService();
      api.passwordResetRequest(this.user)
        .then((response) => {
          this.$swal('送信完了', "パスワードリセットのご案内を登録メールアドレスへ送信致しました。", 'success')
            .then(() => {
              this.$router.push({path: "/app/color/login"});
            });
        })
        .catch((error) => {
          this.$swal('エラー', "メールアドレスが登録されておりません。解決しない場合はサポートチームへご連絡ください。", 'error');
        });
    }
  }
}
</script>
